import { Group, Select, Text } from '@byecode/ui'
import type { DataSourceAbstract } from '@lighthouse/core'
import { FieldIconTypeMap, ListItem4ByecodeUi } from '@lighthouse/shared'
import { useMemo } from 'react'
import { Controller, useFormContext } from 'react-hook-form'

interface Props {
    dataSource: DataSourceAbstract
}

export const TreeFieldSelector = ({ dataSource }: Props) => {
    const { control } = useFormContext()

    const options = useMemo(() => {
        return Object.values(dataSource.schema)
            .filter(item => item.type === 'text')
            .map(item => ({
                label: item.name,
                value: item.id,
                icon: FieldIconTypeMap[item.type]
            }))
    }, [dataSource.schema])

    return (
        <Group label="树形层级结构">
            <ListItem4ByecodeUi alignItems="center" justifyContent="space-between">
                <Text>父层级</Text>
                <Controller
                    name="treeConfig.parentId"
                    control={control}
                    render={({ field }) => {
                        return (
                            <Select
                                style={{ width: 180 }}
                                placeholder="请选择字段"
                                options={options}
                                value={field.value}
                                onChange={field.onChange}
                                searchable
                            />
                        )
                    }}
                />
            </ListItem4ByecodeUi>
        </Group>
    )
}
